// extracted by mini-css-extract-plugin
export default {"tableDetails":"TableDetails_tableDetails__zjSly"};